import { FC, memo } from 'react';

import './ButtonGroup.scss';
import ButtonGroupItem from './ButtonGroupItem';

interface ButtonGroupProps {
  options: { label: string; value: string; disabled: boolean }[];
  value: string;
  onClick: (value: string) => void;
}

const ButtonGroupComponent: FC<ButtonGroupProps> = ({ options, value, onClick }) => {
  return (
    <div className="nostra__buttonGroup">
      {options.map(option => {
        return (
          <ButtonGroupItem
            key={option.value}
            label={option.label}
            value={option.value}
            active={value === option.value}
            disabled={option.disabled}
            onClick={onClick}
          />
        );
      })}
    </div>
  );
};
export const ButtonGroup = memo(ButtonGroupComponent);
